import { readAppEnv } from "@/lib/env";

export function getSiteOrigin(): string {
  try {
    return readAppEnv().baseUrl.replace(/\/$/, "");
  } catch {
    return "http://localhost:4174";
  }
}

export function absoluteUrl(path: string): string {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  const origin = getSiteOrigin();
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}
